/* ==========================================================================
   Store Locator
   Vanilla JS, no build step. Designed to drop into a Shopify theme.

   Boot sequence:
     1. data/locations.js defines window.STORE_LOCATOR_DATA + _CATEGORIES
     2. The Google Maps script is loaded with &callback=slInitLocator
     3. slInitLocator() finds every [data-store-locator] element and boots one
        StoreLocator instance per element.

   The Google Maps JS API key is read from the element's data-api-key OR the
   host page can just include the Maps script tag itself. Either works.
   ========================================================================== */
(function () {
  'use strict';

  /* ----------------------------------------------------------- helpers --- */

  // Small SVG icon set (inline so there are no extra asset requests).
  var ICONS = {
    pin: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0Z"/><circle cx="12" cy="10" r="3"/></svg>',
    crosshair: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="8"/><line x1="12" y1="2" x2="12" y2="5"/><line x1="12" y1="19" x2="12" y2="22"/><line x1="2" y1="12" x2="5" y2="12"/><line x1="19" y1="12" x2="22" y2="12"/><circle cx="12" cy="12" r="2.5" fill="currentColor" stroke="none"/></svg>',
    store: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9 4 4h16l1 5"/><path d="M4 9v11h16V9"/><path d="M4 9a2 2 0 0 0 4 0 2 2 0 0 0 4 0 2 2 0 0 0 4 0 2 2 0 0 0 4 0"/></svg>',
    glass: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 22h8"/><path d="M12 15v7"/><path d="M5 3h14l-2 8a5 5 0 0 1-10 0Z"/></svg>',
    // Cannabis leaf — Font Awesome Free 6 "cannabis". Icons are CC BY 4.0:
    // https://fontawesome.com/license/free (attribution satisfied by this note).
    // Deliberately FILLED while the rest of this set is stroked, and drawn with
    // few fat leaflets rather than a botanically accurate serrated 7-leaflet
    // leaf — that detail collapses into an unreadable asterisk at the 15px we
    // render in the filter chips. Its 512 viewBox differs from the 24 used
    // elsewhere; harmless, since CSS sizes each icon.
    cannabis: '<svg viewBox="0 0 512 512" fill="currentColor"><path d="M256 0c5.3 0 10.3 2.7 13.3 7.1c15.8 23.5 36.7 63.7 49.2 109c7.2 26.4 11.8 55.2 10.4 84c11.5-8.8 23.7-16.7 35.8-23.6c41-23.3 84.4-36.9 112.2-42.5c5.2-1 10.7 .6 14.4 4.4s5.4 9.2 4.4 14.5c-5.6 27.7-19.3 70.9-42.7 111.7c-9.1 15.9-19.9 31.7-32.4 46.3c27.8 6.6 52.4 17.3 67.2 25.5c5.1 2.8 8.2 8.2 8.2 14s-3.2 11.2-8.2 14c-15.2 8.4-40.9 19.5-69.8 26.1c-20.2 4.6-42.9 7.2-65.2 4.6l8.3 33.1c1.5 6.1-.6 12.4-5.5 16.4s-11.6 4.6-17.2 1.9L280 417.2l0 70.8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-70.8-58.5 29.1c-5.6 2.8-12.3 2.1-17.2-1.9s-7-10.3-5.5-16.4l8.3-33.1c-22.2 2.6-45 0-65.2-4.6c-28.9-6.6-54.6-17.6-69.8-26.1c-5.1-2.8-8.2-8.2-8.2-14s3.2-11.2 8.2-14c14.8-8.2 39.4-18.8 67.2-25.5C78.9 296.3 68.1 280.5 59 264.6c-23.4-40.8-37.1-84-42.7-111.7c-1.1-5.2 .6-10.7 4.4-14.5s9.2-5.4 14.4-4.4c27.9 5.5 71.2 19.2 112.2 42.5c12.1 6.9 24.3 14.7 35.8 23.6c-1.4-28.7 3.1-57.6 10.4-84c12.5-45.3 33.4-85.5 49.2-109c3-4.4 8-7.1 13.3-7.1z"/></svg>',
    directions: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="3 11 22 2 13 21 11 13 3 11"/></svg>',
    phone: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3-8.6A2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L8.1 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2Z"/></svg>',
    empty: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="8" y1="11" x2="14" y2="11"/></svg>',
    box: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m21 8-9-5-9 5v8l9 5 9-5V8Z"/><path d="m3 8 9 5 9-5"/><path d="M12 13v8"/></svg>',
    x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
    refresh: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 0 1 15-6.7L21 8"/><path d="M21 3v5h-5"/><path d="M21 12a9 9 0 0 1-15 6.7L3 16"/><path d="M3 21v-5h5"/></svg>',
  };

  function categoryIcon(type) {
    var cats = window.STORE_LOCATOR_CATEGORIES || {};
    var slug = cats[type] && cats[type].icon;
    return ICONS[slug] || ICONS.store;
  }

  function el(tag, className, html) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (html != null) node.innerHTML = html;
    return node;
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // High-resolution clock for debug timing, with a fallback.
  function now() {
    return typeof performance !== 'undefined' && performance.now
      ? performance.now()
      : Date.now();
  }

  function countSource(list, src) {
    var n = 0;
    for (var i = 0; i < list.length; i++) if (list[i] && list[i].source === src) n++;
    return n;
  }

  // localStorage can throw (private mode, blocked cookies) — guard both ways.
  function safeLocalStorageGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }
  function safeLocalStorageSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {
      /* ignore */
    }
  }

  // Great-circle distance in miles (haversine).
  function distanceMiles(a, b) {
    var R = 3958.8;
    var dLat = ((b.lat - a.lat) * Math.PI) / 180;
    var dLng = ((b.lng - a.lng) * Math.PI) / 180;
    var lat1 = (a.lat * Math.PI) / 180;
    var lat2 = (b.lat * Math.PI) / 180;
    var h =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.sin(dLng / 2) * Math.sin(dLng / 2) * Math.cos(lat1) * Math.cos(lat2);
    return 2 * R * Math.asin(Math.sqrt(h));
  }

  function formatDistance(mi) {
    if (mi == null) return '';
    if (mi < 0.1) return '< 0.1 mi';
    if (mi < 10) return mi.toFixed(1) + ' mi';
    return Math.round(mi) + ' mi';
  }

  // Trim entries and drop blanks from a list field.
  function cleanStrings(arr) {
    if (!Array.isArray(arr)) return [];
    var out = [];
    for (var i = 0; i < arr.length; i++) {
      var s = arr[i] == null ? '' : String(arr[i]).trim();
      if (s) out.push(s);
    }
    return out;
  }

  // Restore brand punctuation VIP strips from its data (it disallows
  // apostrophes). "HIER BOY" / "HI ER BOY" -> "HI'ER BOY". Case-preserving: it
  // inserts the apostrophe (and drops the stray space) without recasing, so it's
  // a no-op if the apostrophe is already present.
  function fixProductName(name) {
    return String(name).replace(/(HI) ?(ER BOY)/gi, "$1'$2");
  }

  // Defensive normalization for whatever list-field data we're handed (VIP,
  // sheet, or static sample) so no consumer ever renders an empty product/
  // package bullet or an inflated count. Cleans in place and returns the list.
  function normalizeStores(stores) {
    for (var i = 0; i < stores.length; i++) {
      var s = stores[i];
      if (!s) continue;
      if (s.products) s.products = cleanStrings(s.products).map(fixProductName);
      if (s.packages) s.packages = cleanStrings(s.packages);
    }
    return stores;
  }

  // Radius options (miles). Shared by the filter pills and the auto-expand
  // ladder, so they can't drift out of sync.
  var RADIUS_STEPS = [5, 10, 25, 50];

  // How many locations to request per search. VIP caps a search at 400 total,
  // so asking for 400 loads EVERYTHING within the radius in one shot — the map
  // shows the full spread of pins and the list isn't truncated. (A smaller page
  // size would only show the nearest N and undersell how many locations exist.)
  var PAGE_SIZE = 400;

  // Grid-cell size (px) for clustering: pins within this of a cluster seed get
  // grouped. A pin is ~30px wide × ~47px tall, so this is sized so pins only
  // cluster once they're close to actually overlapping — pins with visible
  // space between them stay separate. Because it's measured in screen pixels,
  // it's automatically zoom-aware: a dense metro crowds within this at low zoom
  // (clusters), and the same pins spread past it as you zoom in (split apart).
  // Raise it for fewer/looser clusters, lower it for tighter, more aggressive.
  var CLUSTER_GRID_PX = 18;

  // Clicking a cluster steps IN by this many zoom levels (centered on it),
  // rather than fitting its members edge-to-edge — a fit slams tight clusters
  // to max zoom and leaves the pins at the map edges. Each level ~doubles the
  // pixel spread, so +3 reliably splits any cluster whose pins aren't stacked,
  // while staying comfortable. Capped so we never zoom past street level.
  var CLUSTER_ZOOM_STEP = 3;
  var CLUSTER_MAX_ZOOM = 17;

  // Greedy pixel-grid clustering: project each store to pixels at the current
  // zoom, then group any within CLUSTER_GRID_PX of a seed. Returns an array of
  // clusters (each an array of stores), or null if the projection isn't ready
  // yet (caller falls back to individual pins). O(n²) but n ≤ 400, so trivial.
  function clusterByPixelGrid(stores, map) {
    var proj = map.getProjection && map.getProjection();
    if (!proj) return null;
    var scale = Math.pow(2, map.getZoom());
    var pts = [];
    for (var i = 0; i < stores.length; i++) {
      var wp = proj.fromLatLngToPoint(
        new google.maps.LatLng(stores[i].lat, stores[i].lng)
      );
      pts.push({ s: stores[i], x: wp.x * scale, y: wp.y * scale, used: false });
    }
    var clusters = [];
    for (var a = 0; a < pts.length; a++) {
      if (pts[a].used) continue;
      pts[a].used = true;
      var group = [pts[a].s];
      for (var b = a + 1; b < pts.length; b++) {
        if (pts[b].used) continue;
        if (
          Math.abs(pts[a].x - pts[b].x) <= CLUSTER_GRID_PX &&
          Math.abs(pts[a].y - pts[b].y) <= CLUSTER_GRID_PX
        ) {
          pts[b].used = true;
          group.push(pts[b].s);
        }
      }
      clusters.push(group);
    }
    return clusters;
  }

  // Circular count badge used as an AdvancedMarkerElement's content for a
  // cluster. Size scales with the count. Background is the theme accent.
  function clusterBadge(count, color) {
    var size = count < 10 ? 34 : count < 50 ? 42 : count < 200 ? 50 : 58;
    var div = el('div', 'sl-cluster');
    div.style.width = size + 'px';
    div.style.height = size + 'px';
    div.style.background = color;
    div.textContent = String(count);
    return div;
  }

  /* ============================================================ class === */

  function StoreLocator(root) {
    this.root = root;
    this.apiKey = root.getAttribute('data-api-key') || '';
    this.mapId = root.getAttribute('data-map-id') || 'DEMO_MAP_ID';
    // data-map="off" boots the widget WITHOUT Google Maps (no map, no
    // autocomplete geocoding) — useful for testing the proxy/list UI locally
    // without a Google API key.
    this.mapEnabled = root.getAttribute('data-map') !== 'off';
    this.categories = window.STORE_LOCATOR_CATEGORIES || {};

    // Data source. "static" uses the hard-coded sample array and filters
    // client-side. "remote" queries the VIP proxy (search-around-a-point) and
    // renders whatever it returns. See data-source / data-proxy-url attributes.
    this.source =
      root.getAttribute('data-source') === 'remote' ? 'remote' : 'static';
    this.proxyUrl = root.getAttribute('data-proxy-url') || '';
    // Default metro used to seed the map before the user searches (remote mode).
    this.defaultCenter = {
      lat: parseFloat(root.getAttribute('data-default-lat')) || 40.7484,
      lng: parseFloat(root.getAttribute('data-default-lng')) || -73.9857,
    };
    // Human-readable name for that default center (e.g. "New York, NY"). Shown
    // in the search box on load so it's obvious what the results are near.
    // Set explicitly rather than reverse-geocoded: that would need the
    // Geocoding API enabled on the browser key (it isn't) plus a paid lookup
    // on every page load, just to render a label we already know.
    this.defaultLabel = root.getAttribute('data-default-label') || '';
    this.stores = normalizeStores(
      this.source === 'remote' ? [] : (window.STORE_LOCATOR_DATA || []).slice()
    );

    // Theme colors read from CSS so pins match the accent.
    var cs = getComputedStyle(root);
    this.accent = cs.getPropertyValue('--sl-accent').trim() || '#12b0c4';
    this.accentDark = cs.getPropertyValue('--sl-accent-dark').trim() || '#0e8fa0';

    // State
    this.origin = null; // {lat,lng} the "you are here" marker (user search)
    this.searchCenter = null; // {lat,lng} center of the current remote query
    this.radius = 10; // miles
    this.activeCategories = Object.keys(this.categories); // all on by default
    this.visible = []; // stores currently shown (with .distance)
    this.activeId = null;

    // Remote pagination
    this.page = 0;
    this.totalPages = 0;
    this.remoteTotal = 0;
    this.onlineVendors = [];
    this.loading = false;

    // Debug mode (internal testing). The toggle only appears when debug is
    // "available": a data-debug attribute is present or ?sldebug is in the URL,
    // so end users never see it. State persists in localStorage.
    this.debugAvailable =
      root.hasAttribute('data-debug') || /[?&]sldebug\b/.test(location.search);
    this.debug =
      this.debugAvailable &&
      (root.getAttribute('data-debug') === 'on' ||
        /[?&]sldebug=1\b/.test(location.search) ||
        safeLocalStorageGet('sl-debug') === '1');
    this.lastRequest = null; // {url, center, miles, page, at}
    this.lastResponse = null; // {status, durationMs, total, ...}

    // Marker clustering. On in production; a debug-mode toggle can disable it
    // (persisted) to compare/tune. Only debug users can turn it off.
    this.clusteringOn = !(
      this.debugAvailable && safeLocalStorageGet('sl-cluster') === 'off'
    );
    this._markerStats = { pins: 0, clusters: 0 };

    // Maps objects (populated once the libraries load)
    this.map = null;
    this.markers = {}; // id -> singleton (unclustered) marker, for highlight/select
    this.mapMarkers = []; // every marker currently on the map (singletons + clusters)
    this.infoWindow = null;
    this.originMarker = null;
    this.AdvancedMarkerElement = null;
    this.PinElement = null;

    // Autocomplete (Places data API)
    this.placesLib = null;
    this.sessionToken = null;
    this.predictions = []; // current placePrediction objects
    this.activeSuggestion = -1; // keyboard-highlighted index
    this._acDebounce = null;

    this.buildDom();
    this.bindEvents();
    this.initMap();
  }

  /* ---------------------------------------------------------- markup --- */
  StoreLocator.prototype.buildDom = function () {
    var self = this;
    this.root.classList.add('sl-locator');
    this.root.setAttribute('data-view', 'list');
    if (this.debug) this.root.classList.add('sl-debug');

    // --- Panel ------------------------------------------------------------
    var panel = el('div', 'sl-panel');

    // No heading here on purpose — the host page/section supplies its own.
    var header = el('div', 'sl-panel__header');

    // Search row. Custom input + a suggestions dropdown we render ourselves,
    // powered by the Places AutocompleteSuggestion data API (see initAutocomplete).
    var search = el('div', 'sl-search');
    var field = el('div', 'sl-search__field');
    var pinIcon = el('span', 'sl-search__pin', ICONS.pin);
    var input = el('input', 'sl-search__input');
    input.type = 'text';
    input.placeholder = 'Enter address, city, or ZIP';
    input.autocomplete = 'off';
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    var suggestions = el('ul', 'sl-suggestions');
    suggestions.setAttribute('role', 'listbox');
    suggestions.hidden = true;
    field.appendChild(pinIcon);
    field.appendChild(input);
    field.appendChild(suggestions);

    var geoBtn = el('button', 'sl-iconbtn', ICONS.crosshair);
    geoBtn.type = 'button';
    geoBtn.title = 'Use my location';
    geoBtn.setAttribute('aria-label', 'Use my location');
    search.appendChild(field);
    search.appendChild(geoBtn);
    header.appendChild(search);

    // Controls: radius pills + category chips
    var controls = el('div', 'sl-controls');

    var radiusWrap = el('div');
    radiusWrap.appendChild(el('span', 'sl-field-label', 'Within'));
    var pills = el('div', 'sl-pills');
    RADIUS_STEPS.forEach(function (mi) {
      var p = el('button', 'sl-pill' + (mi === self.radius ? ' is-active' : ''), mi + ' mi');
      p.type = 'button';
      p.setAttribute('data-radius', String(mi));
      pills.appendChild(p);
    });
    radiusWrap.appendChild(pills);
    controls.appendChild(radiusWrap);

    // Mobile List/Map toggle lives in the controls row, right-aligned
    var viewToggle = el('div', 'sl-viewtoggle');
    var vpills = el('div', 'sl-pills');
    var listV = el('button', 'sl-pill is-active', 'List');
    listV.type = 'button';
    listV.setAttribute('data-view-btn', 'list');
    var mapV = el('button', 'sl-pill', 'Map');
    mapV.type = 'button';
    mapV.setAttribute('data-view-btn', 'map');
    vpills.appendChild(listV);
    vpills.appendChild(mapV);
    viewToggle.appendChild(vpills);
    controls.appendChild(viewToggle);

    header.appendChild(controls);

    // Category chips
    var chips = el('div', 'sl-chips');
    chips.style.marginTop = '14px';
    Object.keys(this.categories).forEach(function (key) {
      var cat = self.categories[key];
      var chip = el(
        'button',
        'sl-chip is-active',
        categoryIcon(key) + '<span>' + escapeHtml(cat.label) + '</span>'
      );
      chip.type = 'button';
      chip.setAttribute('data-category', key);
      chips.appendChild(chip);
    });
    if (Object.keys(this.categories).length > 1) header.appendChild(chips);

    panel.appendChild(header);

    // Results bar + list
    var resultsBar = el('div', 'sl-resultsbar');
    var list = el('div', 'sl-list');
    panel.appendChild(resultsBar);
    panel.appendChild(list);

    // --- Debug footer -----------------------------------------------------
    // All debug UI lives at the BOTTOM of the panel so it never affects the
    // top of the tool. The footer only exists when debug is available, so
    // customers get no extra chrome at all.
    var debugToggle = null;
    var debugPanel = null;
    var clusterToggle = null;
    if (this.debugAvailable) {
      var footer = el('div', 'sl-panel__footer');
      debugPanel = el('div', 'sl-dbg sl-debug-panel');

      // Debug-only tuning controls (shown when debug mode is on).
      var dbgControls = el('div', 'sl-dbg sl-debug-controls');
      clusterToggle = el(
        'button',
        'sl-dbg-btn' + (this.clusteringOn ? '' : ' is-off'),
        'Clustering: ' + (this.clusteringOn ? 'ON' : 'OFF')
      );
      clusterToggle.type = 'button';
      dbgControls.appendChild(clusterToggle);

      debugToggle = el('button', 'sl-debug-toggle', '● DEBUG');
      debugToggle.type = 'button';
      debugToggle.title = 'Toggle debug mode';

      footer.appendChild(dbgControls);
      footer.appendChild(debugPanel);
      footer.appendChild(debugToggle);
      panel.appendChild(footer);
    }

    // --- Map --------------------------------------------------------------
    var mapWrap = el('div', 'sl-map');
    var canvas = el('div', 'sl-map__canvas');
    var loading = el('div', 'sl-map__loading', 'Loading map…');
    // "Search this area" — appears when the user pans/zooms the map (remote mode).
    var areaBtn = el('button', 'sl-area-search', ICONS.refresh + 'Search this area');
    areaBtn.type = 'button';
    areaBtn.hidden = true;
    mapWrap.appendChild(canvas);
    mapWrap.appendChild(loading);
    mapWrap.appendChild(areaBtn);

    this.root.appendChild(panel);
    this.root.appendChild(mapWrap);

    // --- Products modal (hidden until opened) -----------------------------
    var modal = el('div', 'sl-modal');
    modal.setAttribute('hidden', '');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.innerHTML =
      '<div class="sl-modal__backdrop"></div>' +
      '<div class="sl-modal__dialog">' +
      '<div class="sl-modal__header">' +
      '<p class="sl-modal__eyebrow">' + ICONS.box + '<span>Available At</span></p>' +
      '<h3 class="sl-modal__title"></h3>' +
      '<p class="sl-modal__sub"></p>' +
      '<button type="button" class="sl-modal__close" aria-label="Close">' + ICONS.x + '</button>' +
      '</div>' +
      '<div class="sl-modal__body"><ul class="sl-modal__products"></ul></div>' +
      '</div>';
    this.root.appendChild(modal);

    // Cache references
    this.dom = {
      searchInput: input,
      suggestions: suggestions,
      geoBtn: geoBtn,
      pills: pills,
      chips: chips,
      viewToggle: viewToggle,
      resultsBar: resultsBar,
      debugToggle: debugToggle,
      debugPanel: debugPanel,
      clusterToggle: clusterToggle,
      list: list,
      canvas: canvas,
      loading: loading,
      areaBtn: areaBtn,
      modal: modal,
      modalTitle: modal.querySelector('.sl-modal__title'),
      modalSub: modal.querySelector('.sl-modal__sub'),
      modalProducts: modal.querySelector('.sl-modal__products'),
    };
  };

  /* ----------------------------------------------------------- events --- */
  StoreLocator.prototype.bindEvents = function () {
    var self = this;

    // Radius pills
    this.dom.pills.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-radius]');
      if (!btn) return;
      self.radius = parseInt(btn.getAttribute('data-radius'), 10);
      self.setActivePill(self.dom.pills, btn);
      if (self.source === 'remote') {
        // Radius maps to VIP's `miles` param — re-query around the same center.
        if (self.searchCenter) self.remoteFetch({ center: self.searchCenter });
      } else {
        self.update({ fit: true });
      }
    });

    // Category chips
    this.dom.chips.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-category]');
      if (!chip) return;
      var key = chip.getAttribute('data-category');
      chip.classList.toggle('is-active');
      var active = [];
      self.dom.chips.querySelectorAll('.sl-chip.is-active').forEach(function (c) {
        active.push(c.getAttribute('data-category'));
      });
      // Prevent turning everything off — keep at least this one on.
      if (active.length === 0) {
        chip.classList.add('is-active');
        active = [key];
      }
      self.activeCategories = active;
      self.update({ fit: true });
    });

    // Mobile view toggle
    this.dom.viewToggle.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-view-btn]');
      if (!btn) return;
      var view = btn.getAttribute('data-view-btn');
      self.root.setAttribute('data-view', view);
      self.setActivePill(btn.parentNode, btn);
      if (view === 'map' && self.map) {
        google.maps.event.trigger(self.map, 'resize');
        self.fitToVisible();
      }
    });

    // Geolocation
    this.dom.geoBtn.addEventListener('click', function () {
      self.useMyLocation();
    });

    // "Search this area" — re-run the search centered on the current map view,
    // with a radius sized to what's visible. Keep the current camera (no re-fit)
    // so the map stays where the user put it.
    this.dom.areaBtn.addEventListener('click', function () {
      self.searchThisArea();
    });

    // Debug toggle
    if (this.dom.debugToggle) {
      this.dom.debugToggle.addEventListener('click', function () {
        self.debug = !self.debug;
        self.root.classList.toggle('sl-debug', self.debug);
        safeLocalStorageSet('sl-debug', self.debug ? '1' : '0');
        self.renderDebugPanel();
      });
    }

    // Debug: clustering on/off (for comparing settings)
    if (this.dom.clusterToggle) {
      this.dom.clusterToggle.addEventListener('click', function () {
        self.clusteringOn = !self.clusteringOn;
        self.dom.clusterToggle.textContent =
          'Clustering: ' + (self.clusteringOn ? 'ON' : 'OFF');
        self.dom.clusterToggle.classList.toggle('is-off', !self.clusteringOn);
        safeLocalStorageSet('sl-cluster', self.clusteringOn ? 'on' : 'off');
        self.renderMarkers();
        self.renderDebugPanel();
      });
    }

    // List row interactions (delegated)
    this.dom.list.addEventListener('click', function (e) {
      var toggle = e.target.closest('.sl-products__toggle');
      if (toggle) {
        self.openProductsModal(toggle.getAttribute('data-products-for'));
        return;
      }
      if (e.target.closest('.sl-card__actions')) return; // let links work
      var card = e.target.closest('.sl-card');
      if (!card) return;
      self.selectStore(card.getAttribute('data-id'), { pan: true });
    });

    // Modal: close on backdrop click, close button, or Escape
    this.dom.modal.addEventListener('click', function (e) {
      if (e.target.closest('.sl-modal__close') || e.target.classList.contains('sl-modal__backdrop')) {
        self.closeProductsModal();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !self.dom.modal.hasAttribute('hidden')) {
        self.closeProductsModal();
      }
    });
  };

  StoreLocator.prototype.setActivePill = function (container, activeBtn) {
    container.querySelectorAll('.sl-pill, .sl-chip').forEach(function (b) {
      b.classList.remove('is-active');
    });
    activeBtn.classList.add('is-active');
  };

  /* -------------------------------------------------------------- map --- */
  // Async: dynamically imports only the libraries we use. Uses the modern
  // AdvancedMarkerElement + AutocompleteSuggestion APIs (no deprecated APIs).
  StoreLocator.prototype.initMap = function () {
    var self = this;

    // No-map test mode (or Maps simply isn't present): render the list/data
    // without any Google dependency.
    if (!this.mapEnabled || typeof google === 'undefined' || !google.maps) {
      this.initDataOnly();
      return;
    }

    Promise.all([
      google.maps.importLibrary('maps'),
      google.maps.importLibrary('marker'),
      google.maps.importLibrary('places'),
    ])
      .then(function (libs) {
        var mapsLib = libs[0];
        var markerLib = libs[1];
        var placesLib = libs[2];

        self.AdvancedMarkerElement = markerLib.AdvancedMarkerElement;
        self.PinElement = markerLib.PinElement;

        // A mapId is REQUIRED for AdvancedMarkerElement. Note: when a mapId is
        // set, inline `styles` are ignored — map styling is configured on the
        // Map ID in the Google Cloud console (cloud-based map styling).
        self.map = new mapsLib.Map(self.dom.canvas, {
          center: { lat: 40.7484, lng: -73.9857 }, // NYC default
          zoom: 12,
          mapId: self.mapId,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: true,
          // On-screen +/- zoom buttons so visitors can zoom without ⌘/Ctrl+scroll.
          zoomControl: true,
          // Keep scroll-to-zoom gated behind ⌘/Ctrl so scrolling the page over
          // the map doesn't hijack it (esp. on mobile). The buttons cover the
          // rest. This is Google's default when the map is in a scrollable page,
          // but we set it explicitly so the behavior is intentional.
          gestureHandling: 'cooperative',
          clickableIcons: false,
        });
        // headerDisabled removes Google's header row (and its close button) —
        // that row is what leaves dead space above the title. We render our own
        // header + close button inside the content instead.
        self.infoWindow = new google.maps.InfoWindow({ headerDisabled: true });
        self.dom.loading.style.display = 'none';

        // "Search this area": when the user pans/zooms (remote mode), reveal the
        // button. We suppress the `idle` that follows our OWN camera moves
        // (fit-to-results, select-store pan) so it only reacts to real input.
        self.map.addListener('idle', function () {
          if (self._suppressIdle) {
            self._suppressIdle = false;
            clearTimeout(self._suppressTimer);
            return;
          }
          if (self.source === 'remote' && self.searchCenter && !self.loading) {
            self.dom.areaBtn.hidden = false;
          }
        });

        // Clusters are pixel-based, so they change with zoom — recompute after
        // the zoom settles (debounced to avoid thrashing during animation).
        self.map.addListener('zoom_changed', function () {
          clearTimeout(self._clusterTimer);
          self._clusterTimer = setTimeout(function () {
            self.renderMarkers();
          }, 140);
        });

        // Guard: a Places-API misconfig shouldn't take down the map/markers.
        try {
          self.initAutocomplete(placesLib);
        } catch (e) {
          if (window.console) console.warn('[store-locator] autocomplete unavailable', e);
        }

        if (self.source === 'remote') {
          self.seedDefaultCenter();
        } else {
          self.update({ fit: true }); // update() renders the (clustered) markers
        }
      })
      .catch(function (err) {
        self.dom.loading.textContent =
          'Map failed to load. Check the Google Maps API key.';
        if (window.console) console.error('[store-locator]', err);
      });
  };

  // Boot without Google Maps: placeholder in the map area, list rendered from
  // data (remote proxy results seeded at the default center, or static sample).
  StoreLocator.prototype.initDataOnly = function () {
    this.dom.loading.textContent = 'Map disabled (test mode)';
    this.dom.loading.style.display = '';
    this.dom.searchInput.disabled = true;
    this.dom.searchInput.placeholder = 'Search disabled — map-off test mode';

    if (this.source === 'remote') {
      this.seedDefaultCenter();
    } else {
      this.update({ fit: false });
    }
  };

  // Show an auto-generated label (default metro, "Current location") as a greyed
  // PLACEHOLDER with the field empty — so it still tells the visitor what the
  // results are near, but they can start typing a new location without having to
  // clear it first. (A place the visitor actually picks from autocomplete is set
  // as a real value instead, since it's their input and should stay editable.)
  StoreLocator.prototype.setSearchHint = function (text) {
    if (!this.dom.searchInput) return;
    this.dom.searchInput.value = '';
    if (text) this.dom.searchInput.placeholder = text;
  };

  // Seed the map at the configured default center, and reflect that location in
  // the search box (as a placeholder hint) so it's obvious what results are near.
  StoreLocator.prototype.seedDefaultCenter = function () {
    if (this.defaultLabel) this.setSearchHint(this.defaultLabel);
    this.remoteFetch({ center: this.defaultCenter, showOrigin: false, autoExpand: true });
  };

  // Wire our own input to the Places AutocompleteSuggestion data API so we
  // fully own the input + dropdown styling (no shadow-DOM widget).
  StoreLocator.prototype.initAutocomplete = function (placesLib) {
    var self = this;
    if (!placesLib || !placesLib.AutocompleteSuggestion) return;
    this.placesLib = placesLib;
    this.newSessionToken();

    var input = this.dom.searchInput;

    input.addEventListener('input', function () {
      clearTimeout(self._acDebounce);
      var q = input.value.trim();
      if (q.length < 3) {
        self.closeSuggestions();
        return;
      }
      self._acDebounce = setTimeout(function () {
        self.fetchSuggestions(q);
      }, 200);
    });

    input.addEventListener('keydown', function (e) {
      // Zip + Enter: search immediately (numberpad flow) without picking from
      // the dropdown — even if suggestions haven't loaded yet. Only for a clean
      // 5-digit zip; other input still needs a suggestion selected.
      if (e.key === 'Enter' && /^\d{5}$/.test(input.value.trim())) {
        e.preventDefault();
        // Cancel the pending debounced fetch — otherwise it fires ~200ms later
        // and re-opens the suggestions right after we close them.
        clearTimeout(self._acDebounce);
        self.closeSuggestions();
        self.searchZip(input.value.trim());
        input.blur(); // dismiss the mobile keyboard — done searching
        return;
      }
      if (self.dom.suggestions.hidden) return;
      var max = self.predictions.length - 1;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        self.highlightSuggestion(Math.min(self.activeSuggestion + 1, max));
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        self.highlightSuggestion(Math.max(self.activeSuggestion - 1, 0));
      } else if (e.key === 'Enter') {
        e.preventDefault();
        self.chooseSuggestion(self.activeSuggestion < 0 ? 0 : self.activeSuggestion);
      } else if (e.key === 'Escape') {
        self.closeSuggestions();
      }
    });

    // Close on outside click / blur (delayed so option clicks register first).
    input.addEventListener('blur', function () {
      setTimeout(function () {
        self.closeSuggestions();
      }, 150);
    });

    // Delegate option clicks (mousedown so it beats the input blur).
    this.dom.suggestions.addEventListener('mousedown', function (e) {
      var li = e.target.closest('.sl-suggestion');
      if (!li) return;
      e.preventDefault();
      self.chooseSuggestion(parseInt(li.getAttribute('data-index'), 10));
    });
  };

  StoreLocator.prototype.newSessionToken = function () {
    if (this.placesLib && this.placesLib.AutocompleteSessionToken) {
      this.sessionToken = new this.placesLib.AutocompleteSessionToken();
    }
  };

  StoreLocator.prototype.fetchSuggestions = function (query) {
    var self = this;
    var request = {
      input: query,
      sessionToken: this.sessionToken,
      region: 'us',
    };
    // Bias results toward the currently-viewed area for better local matches.
    var bounds = this.map && this.map.getBounds();
    if (bounds) request.locationBias = bounds;

    this.placesLib.AutocompleteSuggestion.fetchAutocompleteSuggestions(request)
      .then(function (res) {
        var list = (res && res.suggestions) || [];
        self.predictions = list
          .map(function (s) {
            return s.placePrediction;
          })
          .filter(Boolean);
        self.renderSuggestions();
      })
      .catch(function (err) {
        if (window.console) console.warn('[store-locator] suggestions failed', err);
        self.closeSuggestions();
      });
  };

  StoreLocator.prototype.renderSuggestions = function () {
    var self = this;
    var box = this.dom.suggestions;
    this.activeSuggestion = -1;

    if (!this.predictions.length) {
      this.closeSuggestions();
      return;
    }

    box.innerHTML = '';
    this.predictions.forEach(function (p, i) {
      var main = p.mainText ? p.mainText.toString() : p.text.toString();
      var secondary = p.secondaryText ? p.secondaryText.toString() : '';
      var li = el('li', 'sl-suggestion');
      li.setAttribute('role', 'option');
      li.setAttribute('data-index', String(i));
      li.id = self.dom.searchInput.id
        ? self.dom.searchInput.id + '-opt-' + i
        : 'sl-opt-' + i;
      li.innerHTML =
        ICONS.pin +
        '<span class="sl-suggestion__text">' +
        '<span class="sl-suggestion__main">' + escapeHtml(main) + '</span>' +
        (secondary
          ? '<span class="sl-suggestion__sub">' + escapeHtml(secondary) + '</span>'
          : '') +
        '</span>';
      box.appendChild(li);
    });

    box.hidden = false;
    this.dom.searchInput.setAttribute('aria-expanded', 'true');
  };

  StoreLocator.prototype.highlightSuggestion = function (index) {
    this.activeSuggestion = index;
    var items = this.dom.suggestions.querySelectorAll('.sl-suggestion');
    for (var i = 0; i < items.length; i++) {
      var on = i === index;
      items[i].classList.toggle('is-active', on);
      if (on) {
        this.dom.searchInput.setAttribute('aria-activedescendant', items[i].id);
        items[i].scrollIntoView({ block: 'nearest' });
      }
    }
  };

  StoreLocator.prototype.chooseSuggestion = function (index) {
    var self = this;
    var prediction = this.predictions[index];
    if (!prediction) return;

    this.dom.searchInput.value = prediction.text.toString();
    this.closeSuggestions();

    var place = prediction.toPlace();
    place
      .fetchFields({ fields: ['location', 'formattedAddress', 'displayName'] })
      .then(function () {
        if (place.location) {
          self.setOrigin({
            lat: place.location.lat(),
            lng: place.location.lng(),
          });
        }
        // fetchFields concludes the billing session — start a fresh one.
        self.newSessionToken();
      })
      .catch(function (err) {
        if (window.console) console.warn('[store-locator] place details failed', err);
      });
  };

  // Resolve a 5-digit zip to coordinates and search — used by the zip+Enter
  // shortcut. Runs its own Places lookup (biased to postal codes) so it doesn't
  // depend on the debounced suggestion dropdown having loaded yet.
  StoreLocator.prototype.searchZip = function (zip) {
    var self = this;
    if (!this.placesLib || !this.placesLib.AutocompleteSuggestion) return;
    this.dom.searchInput.value = zip;
    this.placesLib.AutocompleteSuggestion.fetchAutocompleteSuggestions({
      input: zip,
      sessionToken: this.sessionToken,
      region: 'us',
      includedPrimaryTypes: ['postal_code'],
    })
      .then(function (res) {
        var list = (res && res.suggestions) || [];
        var pred = null;
        for (var i = 0; i < list.length; i++) {
          if (list[i].placePrediction) { pred = list[i].placePrediction; break; }
        }
        if (!pred) return;
        var place = pred.toPlace();
        return place
          .fetchFields({ fields: ['location', 'formattedAddress'] })
          .then(function () {
            if (place.location) {
              self.setOrigin({
                lat: place.location.lat(),
                lng: place.location.lng(),
              });
            }
            self.newSessionToken();
          });
      })
      .catch(function (err) {
        if (window.console) console.warn('[store-locator] zip search failed', err);
      });
  };

  StoreLocator.prototype.closeSuggestions = function () {
    this.predictions = [];
    this.activeSuggestion = -1;
    this.dom.suggestions.hidden = true;
    this.dom.suggestions.innerHTML = '';
    this.dom.searchInput.setAttribute('aria-expanded', 'false');
    this.dom.searchInput.removeAttribute('aria-activedescendant');
  };

  StoreLocator.prototype.makePin = function (active) {
    return new this.PinElement({
      background: active ? this.accentDark : this.accent,
      borderColor: '#ffffff',
      glyphColor: '#ffffff',
      scale: active ? 1.35 : 1.1,
    });
  };

  // (Re)build markers for the current store set. Idempotent — clears existing
  // markers first so remote mode can call it after every fetch.
  // Draw the visible stores, clustered. Called whenever the visible set changes
  // (search, filter) and on zoom (clusters are pixel-based, so they change with
  // zoom). Clears and redraws — cheap for n ≤ 400.
  StoreLocator.prototype.renderMarkers = function () {
    var self = this;
    if (!this.map) return; // no-map test mode

    this.mapMarkers.forEach(function (m) { m.map = null; });
    this.mapMarkers = [];
    this.markers = {};

    var stores = this.visible.filter(function (s) {
      return s.lat != null && s.lng != null;
    });

    // Clustering off (debug), or projection not ready yet -> individual pins.
    var clusters = this.clusteringOn ? clusterByPixelGrid(stores, this.map) : null;
    if (!clusters) {
      stores.forEach(function (s) { self.addStoreMarker(s); });
      this._markerStats = { pins: stores.length, clusters: 0 };
      return;
    }

    var pins = 0, clusterCount = 0;
    clusters.forEach(function (members) {
      if (members.length === 1) { self.addStoreMarker(members[0]); pins++; }
      else { self.addClusterMarker(members); clusterCount++; }
    });
    this._markerStats = { pins: pins, clusters: clusterCount };
  };

  StoreLocator.prototype.addStoreMarker = function (store) {
    var self = this;
    var active = store.id === this.activeId;
    var marker = new this.AdvancedMarkerElement({
      position: { lat: store.lat, lng: store.lng },
      map: this.map,
      title: store.name,
      content: this.makePin(active).element,
      gmpClickable: true,
      zIndex: active ? 1000 : 1,
    });
    marker.addEventListener('gmp-click', function () {
      self.selectStore(store.id, { pan: false });
    });
    this.markers[store.id] = marker;
    this.mapMarkers.push(marker);
  };

  StoreLocator.prototype.addClusterMarker = function (members) {
    var self = this;
    var lat = 0, lng = 0;
    members.forEach(function (s) { lat += s.lat; lng += s.lng; });
    lat /= members.length;
    lng /= members.length;

    var marker = new this.AdvancedMarkerElement({
      position: { lat: lat, lng: lng },
      map: this.map,
      content: clusterBadge(members.length, this.accent),
      gmpClickable: true,
      zIndex: 2,
    });
    marker.addEventListener('gmp-click', function () {
      // Step in toward the cluster (centered on it) rather than fitting its
      // members to the viewport edges. The zoom re-cluster then splits it.
      self.beginProgrammaticMove();
      var target = Math.min(
        CLUSTER_MAX_ZOOM,
        (self.map.getZoom() || 12) + CLUSTER_ZOOM_STEP
      );
      self.map.panTo({ lat: lat, lng: lng });
      self.map.setZoom(target);
    });
    this.mapMarkers.push(marker);
  };

  /* ----------------------------------------------------- remote fetch --- */
  // Query the VIP proxy for locations around `center`, map already done
  // Mark the next map camera move as OURS, so the `idle` handler doesn't treat
  // it as user input and pop the "Search this area" button. A fallback timer
  // clears the flag if the move produces no `idle` (e.g. fitting to the same
  // bounds), so it can't get stuck.
  StoreLocator.prototype.beginProgrammaticMove = function () {
    var self = this;
    this._suppressIdle = true;
    clearTimeout(this._suppressTimer);
    this._suppressTimer = setTimeout(function () {
      self._suppressIdle = false;
    }, 600);
  };

  // Re-run the search centered on the current map view (from the "Search this
  // area" button). Radius is sized to cover the visible viewport, snapped to a
  // pill value; the map is NOT re-fit, so the user's view is preserved.
  StoreLocator.prototype.searchThisArea = function () {
    if (!this.map) return;
    this.dom.areaBtn.hidden = true;

    var c = this.map.getCenter();
    var center = { lat: c.lat(), lng: c.lng() };

    // Distance from center to a viewport corner = radius that covers the view.
    var miles = 25;
    var bounds = this.map.getBounds();
    if (bounds) {
      var ne = bounds.getNorthEast();
      miles = distanceMiles(center, { lat: ne.lat(), lng: ne.lng() });
    }
    var r = RADIUS_STEPS[RADIUS_STEPS.length - 1];
    for (var i = 0; i < RADIUS_STEPS.length; i++) {
      if (RADIUS_STEPS[i] >= miles) { r = RADIUS_STEPS[i]; break; }
    }
    this.setRadiusPill(r);

    // The results are for a map area, not the visitor's location — reflect that
    // in the search box rather than leaving a stale address/label.
    this.setSearchHint('Map area');

    // noFit: keep the current camera. No autoExpand: honor the visible area
    // (don't silently widen past what they're looking at).
    this.remoteFetch({ center: center, noFit: true });
  };

  // The next-larger radius step, or null if already at the max.
  StoreLocator.prototype.nextRadiusStep = function () {
    for (var i = 0; i < RADIUS_STEPS.length; i++) {
      if (RADIUS_STEPS[i] > this.radius) return RADIUS_STEPS[i];
    }
    return null;
  };

  // Set the radius and reflect it in the active pill (used by auto-expand so
  // the UI always shows the radius the results are actually within).
  StoreLocator.prototype.setRadiusPill = function (mi) {
    this.radius = mi;
    if (!this.dom.pills) return;
    var btn = this.dom.pills.querySelector('[data-radius="' + mi + '"]');
    if (btn) this.setActivePill(this.dom.pills, btn);
  };

  // server-side. Distance + sort come from VIP; we don't re-filter by radius.
  StoreLocator.prototype.remoteFetch = function (opts) {
    opts = opts || {};
    var self = this;
    var center = opts.center;
    if (!center || !this.proxyUrl) return;

    var append = !!opts.append;
    this.searchCenter = center;
    if (!append) this.page = 0;

    // A search supersedes any pending "Search this area" prompt.
    this.dom.areaBtn.hidden = true;

    // Drop the "you are here" dot for explicit user searches.
    if (opts.showOrigin) this.placeOriginMarker(center);

    this.loading = true;
    this.renderResultsBar();

    var url = new URL(this.proxyUrl, window.location.href);
    url.searchParams.set('lat', center.lat.toFixed(6));
    url.searchParams.set('long', center.lng.toFixed(6));
    url.searchParams.set('miles', String(this.radius));
    url.searchParams.set('page', String(this.page));
    url.searchParams.set('pagesize', String(PAGE_SIZE));

    var t0 = now();
    var httpStatus = null;
    this.lastRequest = {
      url: url.toString(),
      center: { lat: center.lat, lng: center.lng },
      miles: this.radius,
      page: this.page,
      append: append,
      at: new Date(),
    };
    this.lastResponse = null;
    this.renderDebugPanel();

    fetch(url.toString(), { headers: { Accept: 'application/json' } })
      .then(function (r) {
        httpStatus = r.status;
        if (!r.ok) throw new Error('proxy HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        self.loading = false;
        var incoming = normalizeStores((data && data.locations) || []);

        // Auto-expand: a fresh location search that came back empty widens to
        // the next radius step and retries — until results appear or we hit the
        // max (50 mi). e.g. Laguna Beach: nothing at 10, retries 25, then 50.
        if (opts.autoExpand && !append && incoming.length === 0) {
          var next = self.nextRadiusStep();
          if (next != null) {
            self.setRadiusPill(next); // updates this.radius + the active pill
            self.remoteFetch({ center: center, autoExpand: true });
            return; // the retry renders; don't flash an empty state in between
          }
        }

        self.stores = append ? self.stores.concat(incoming) : incoming;
        // Capture the total/pages from the FRESH search only. The proxy merges
        // sheet rows into `total` on page 0 but not on later pages, so updating
        // these on "Load more" would make the total drop by the sheet count.
        // They describe the whole search, not the page, so page 0 is correct.
        if (!append) {
          self.remoteTotal = (data && data.total) || self.stores.length;
          self.totalPages = (data && data.totalPages) || 0;
        }
        self.onlineVendors = (data && data.onlineVendors) || [];
        self.lastResponse = {
          status: httpStatus,
          durationMs: Math.round(now() - t0),
          total: data && data.total,
          totalPages: data && data.totalPages,
          returned: incoming.length,
          vipCount: countSource(incoming, 'vip'),
          sheetCount: countSource(incoming, 'sheet'),
          // Anything not tagged vip/sheet — e.g. a proxy deploy predating the
          // `source` field. Surfaced so the counts never silently mislead.
          untagged:
            incoming.length -
            countSource(incoming, 'vip') -
            countSource(incoming, 'sheet'),
          onlineVendors: self.onlineVendors.length,
          errMsg: (data && data.errMsg) || (data && data.error) || '',
        };
        // Don't re-fit the camera for a "Search this area" search — keep the
        // view the user set. Otherwise fit to the fresh results. update()
        // renders the (clustered) markers.
        self.update({ fit: !append && !opts.noFit });
      })
      .catch(function (err) {
        self.loading = false;
        if (window.console) console.warn('[store-locator] search failed', err);
        self.lastResponse = {
          status: httpStatus || 'ERR',
          durationMs: Math.round(now() - t0),
          error: err.message,
        };
        self.stores = append ? self.stores : [];
        self.renderResultsBar();
        self.renderList();
        self.renderDebugPanel();
      });
  };

  StoreLocator.prototype.placeOriginMarker = function (coords) {
    this.origin = coords;
    if (!this.map) return; // no-map test mode
    if (this.originMarker) this.originMarker.map = null;
    this.originMarker = new this.AdvancedMarkerElement({
      position: coords,
      map: this.map,
      zIndex: 999,
      content: el('div', 'sl-origin-dot'),
      title: 'Your location',
    });
  };

  /* --------------------------------------------------- search / origin --- */
  // Called when the user picks a place or geolocates.
  StoreLocator.prototype.setOrigin = function (coords) {
    if (this.source === 'remote') {
      this.remoteFetch({ center: coords, showOrigin: true, autoExpand: true });
    } else {
      this.placeOriginMarker(coords);
      this.update({ fit: true });
    }
  };

  StoreLocator.prototype.useMyLocation = function () {
    var self = this;
    if (!navigator.geolocation) return;
    this.dom.geoBtn.classList.add('is-loading');
    navigator.geolocation.getCurrentPosition(
      function (pos) {
        self.dom.geoBtn.classList.remove('is-loading');
        // Reflect the new origin in the search box as a placeholder hint —
        // otherwise it keeps showing the previous label while results are now
        // near the visitor, which reads as a bug. Placeholder (not value) so the
        // visitor can type a new location without clearing it first.
        // A literal label rather than the real address: reverse-geocoding would
        // need the Geocoding API on the browser key (not enabled) plus a billed
        // lookup per click. "Current location" is what Maps/Yelp show anyway.
        self.setSearchHint('Current location');
        self.setOrigin({ lat: pos.coords.latitude, lng: pos.coords.longitude });
      },
      function () {
        self.dom.geoBtn.classList.remove('is-loading');
      },
      { enableHighAccuracy: true, timeout: 8000 }
    );
  };

  /* ------------------------------------------------------ core update --- */
  // Recompute the visible set based on origin, radius, categories; then render.
  StoreLocator.prototype.update = function (opts) {
    opts = opts || {};
    var self = this;

    var list = this.stores.filter(function (s) {
      return self.activeCategories.indexOf(s.type) !== -1;
    });

    if (this.source === 'remote') {
      // VIP already filtered by radius and sorted by distance; keep its values.
      list.sort(function (a, b) {
        return (a.distance == null ? 1e9 : a.distance) - (b.distance == null ? 1e9 : b.distance);
      });
    } else if (this.origin) {
      list.forEach(function (s) {
        s.distance = distanceMiles(self.origin, s);
      });
      list = list.filter(function (s) {
        return s.distance <= self.radius;
      });
      list.sort(function (a, b) {
        return a.distance - b.distance;
      });
    } else {
      list.forEach(function (s) {
        s.distance = null;
      });
    }

    this.visible = list;

    // Draw the (clustered) markers for the visible set.
    this.renderMarkers();

    this.renderResultsBar();
    this.renderList();
    this.renderDebugPanel();
    if (opts.fit) this.fitToVisible();
  };

  /* ------------------------------------------------------------ debug --- */
  // Connection-level diagnostics (only meaningful when debug is available;
  // hidden by CSS unless debug mode is on).
  StoreLocator.prototype.renderDebugPanel = function () {
    var panel = this.dom.debugPanel;
    if (!panel || !this.debugAvailable) return;

    function row(k, v) {
      return (
        '<div class="sl-dbg-row"><span class="sl-dbg-k">' + escapeHtml(k) +
        '</span><span class="sl-dbg-v">' + escapeHtml(v) + '</span></div>'
      );
    }

    var rows = row('mode', this.source + (this.mapEnabled ? '' : ' · map:off'));

    if (this.source === 'remote') {
      rows += row('proxy', this.proxyUrl || '(none)');
      var req = this.lastRequest;
      if (req) {
        rows += row(
          'request',
          req.center.lat.toFixed(5) + ', ' + req.center.lng.toFixed(5) +
            ' · ' + req.miles + ' mi · page ' + req.page + (req.append ? ' (append)' : '')
        );
      }
      var res = this.lastResponse;
      if (this.loading && !res) {
        rows += row('status', 'loading…');
      } else if (res && res.error) {
        rows += row('status', res.status + ' · ' + res.durationMs + 'ms');
        rows += row('error', res.error);
      } else if (res) {
        rows += row('status', res.status + ' · ' + res.durationMs + 'ms');
        rows += row(
          'results',
          'returned ' + res.returned + ' · total ' + res.total +
            ' · pages ' + (res.totalPages || 0)
        );
        rows += row(
          'sources',
          'VIP ' + res.vipCount + ' · SHEET ' + res.sheetCount +
            (res.untagged ? ' · UNTAGGED ' + res.untagged + ' (redeploy proxy?)' : '') +
            ' · online ' + res.onlineVendors
        );
        if (res.errMsg) rows += row('errMsg', res.errMsg);
      }
    } else {
      rows += row('sample', this.stores.length + ' locations');
    }

    rows += row(
      'showing',
      (this.visible ? this.visible.length : 0) + ' after filters · cats ' +
        this.activeCategories.join(',')
    );

    // Marker/clustering readout — helps tune CLUSTER_GRID_PX at the current zoom.
    var ms = this._markerStats || { pins: 0, clusters: 0 };
    rows += row(
      'markers',
      ms.pins + ' pins · ' + ms.clusters + ' clusters · ' +
        (this.clusteringOn ? 'grid ' + CLUSTER_GRID_PX + 'px' : 'clustering OFF')
    );

    panel.innerHTML = '<div class="sl-dbg-title">CONNECTION</div>' + rows;
  };

  // Per-card diagnostics. Only emitted when debug is available (so end-user
  // markup never contains it); shown/hidden by the root .sl-debug class.
  StoreLocator.prototype.renderCardDebug = function (store) {
    if (!this.debugAvailable) return '';
    var src = store.source || (this.source === 'remote' ? 'remote' : 'sample');
    function row(k, v) {
      return (
        '<div class="sl-dbg-row"><span class="sl-dbg-k">' + k +
        '</span><span class="sl-dbg-v">' + escapeHtml(v) + '</span></div>'
      );
    }
    var dist = store.distance == null ? '—' : Math.round(store.distance * 1000) / 1000 + ' mi';
    return (
      '<div class="sl-dbg sl-card__dbg">' +
      '<span class="sl-dbg-badge">' + escapeHtml(src) + '</span>' +
      row('id', store.id) +
      row('type', store.type + (store.storeTypeCode ? ' · COT ' + store.storeTypeCode : '')) +
      row('coords', store.lat + ', ' + store.lng) +
      row('distance', dist) +
      row(
        'detail',
        'products ' + (store.products ? store.products.length : 0) +
          ' · pkgs ' + (store.packages ? store.packages.length : 0) +
          ' · hours ' + (store.hours ? '✓' : '✗') +
          ' · phone ' + (store.phone ? '✓' : '✗')
      ) +
      '</div>'
    );
  };

  StoreLocator.prototype.fitToVisible = function () {
    if (!this.map) return;
    this.beginProgrammaticMove(); // our move — don't trigger "Search this area"
    var pts = this.visible.slice();
    var center = this.origin || this.searchCenter;
    if (center) pts = pts.concat([center]);
    if (pts.length === 0) {
      // Nothing to show — center on the search point if we have one.
      if (center) {
        this.map.setCenter({ lat: center.lat, lng: center.lng });
        this.map.setZoom(11);
      }
      return;
    }
    if (pts.length === 1) {
      this.map.setCenter({ lat: pts[0].lat, lng: pts[0].lng });
      this.map.setZoom(14);
      return;
    }
    var bounds = new google.maps.LatLngBounds();
    pts.forEach(function (p) {
      bounds.extend({ lat: p.lat, lng: p.lng });
    });
    this.map.fitBounds(bounds, 60);
  };

  /* ---------------------------------------------------------- rendering --- */
  StoreLocator.prototype.renderResultsBar = function () {
    if (this.loading) {
      this.dom.resultsBar.innerHTML = 'Searching…';
      return;
    }
    var n = this.visible.length; // cards currently loaded + passing the filter
    var label = n === 1 ? 'location' : 'locations';
    var within = this.origin || this.searchCenter ? ' within ' + this.radius + ' mi' : '';

    // Remote results are paginated (50/page), so `n` alone would understate a
    // dense area — it'd cap at the page size. Show the true server total so NYC
    // reads e.g. "Showing 50 of 242", never a misleading flat "50".
    if (this.source === 'remote') {
      var filtered =
        this.activeCategories.length < Object.keys(this.categories).length;
      var total = this.remoteTotal || 0;

      // No category filter → the server total is the true, complete count.
      if (!filtered && total > n) {
        this.dom.resultsBar.innerHTML =
          'Showing <strong>' + n + '</strong> of <strong>' + total +
          '</strong> locations' + within;
        return;
      }
      // A category filter only sees the loaded rows, so the true per-category
      // total across not-yet-loaded pages is unknown — say so rather than
      // print a number that could understate. (Once all pages are loaded, or
      // no filter is active, we fall through to the exact count below.)
      if (filtered && this.page < this.totalPages - 1) {
        this.dom.resultsBar.innerHTML =
          '<strong>' + n + '</strong> ' + label + within + ' (more available)';
        return;
      }
    }

    this.dom.resultsBar.innerHTML = '<strong>' + n + '</strong> ' + label + within;
  };

  StoreLocator.prototype.renderList = function () {
    var self = this;
    var list = this.dom.list;
    list.innerHTML = '';

    if (this.visible.length === 0) {
      var empty = el('div', 'sl-empty');
      empty.innerHTML =
        ICONS.empty +
        '<h4>No locations found</h4>' +
        '<p>Try widening your search radius or searching a different area.</p>';
      list.appendChild(empty);
      return;
    }

    this.visible.forEach(function (store) {
      list.appendChild(self.renderCard(store));
    });

    // Remote mode: offer "load more" when VIP has additional pages.
    if (this.source === 'remote' && this.page < this.totalPages - 1) {
      var more = el('button', 'sl-loadmore', 'Load more locations');
      more.type = 'button';
      more.addEventListener('click', function () {
        self.page += 1;
        self.remoteFetch({ center: self.searchCenter, append: true });
      });
      list.appendChild(more);
    }
  };

  StoreLocator.prototype.renderCard = function (store) {
    var card = el('div', 'sl-card');
    card.setAttribute('data-id', store.id);
    if (store.id === this.activeId) card.classList.add('is-active');

    var cat = this.categories[store.type];
    var distanceHtml = store.distance != null
      ? '<span class="sl-card__distance">' + formatDistance(store.distance) + '</span>'
      : '';

    var addr = escapeHtml(
      store.address + ', ' + store.city + ', ' + store.state + ' ' + store.zip
    );
    var telHref = 'tel:' + (store.phone || '').replace(/[^0-9+]/g, '');
    var mapsUrl =
      'https://www.google.com/maps/dir/?api=1&destination=' +
      encodeURIComponent(
        store.address + ', ' + store.city + ', ' + store.state + ' ' + store.zip
      );

    var html =
      '<div class="sl-card__head">' +
      '<h3 class="sl-card__name">' + escapeHtml(store.name) + '</h3>' +
      distanceHtml +
      '</div>';

    if (cat) {
      html +=
        '<span class="sl-card__badge">' + categoryIcon(store.type) +
        escapeHtml(cat.label) + '</span>';
    }

    html += '<p class="sl-card__meta">' + addr;
    if (store.hours) {
      html += '<br><span class="sl-card__hours">' + escapeHtml(store.hours) + '</span>';
    }
    if (store.phone) {
      html +=
        '<br><a href="' + telHref + '">' + escapeHtml(store.phone) + '</a>';
    }
    html += '</p>';

    // Products trigger — opens the pop-out modal
    if (store.products && store.products.length) {
      html +=
        '<div class="sl-products">' +
        '<button type="button" class="sl-products__toggle" data-products-for="' +
        escapeHtml(store.id) + '">' + ICONS.box +
        'Available Products' +
        '<span class="sl-products__count">' + store.products.length + '</span>' +
        '</button>' +
        '</div>';
    }

    // Actions
    html +=
      '<div class="sl-card__actions">' +
      '<a class="sl-btn sl-btn--primary" href="' + mapsUrl +
      '" target="_blank" rel="noopener">' + ICONS.directions + 'Directions</a>';
    if (store.phone) {
      html +=
        '<a class="sl-btn" href="' + telHref + '">' + ICONS.phone + 'Call</a>';
    }
    html += '</div>';

    // Debug details (present only when debug is available; CSS gates visibility)
    html += this.renderCardDebug(store);

    card.innerHTML = html;
    return card;
  };

  /* --------------------------------------------------- products modal --- */
  StoreLocator.prototype.openProductsModal = function (id) {
    var store = this.stores.filter(function (s) {
      return s.id === id;
    })[0];
    if (!store || !store.products) return;

    this.dom.modalTitle.textContent = store.name;
    this.dom.modalSub.textContent =
      store.address + ', ' + store.city + ', ' + store.state;
    this.dom.modalProducts.innerHTML = store.products
      .map(function (p) {
        return '<li><span class="sl-modal__dot"></span>' + escapeHtml(p) + '</li>';
      })
      .join('');

    this.dom.modal.removeAttribute('hidden');
    // Lock background scroll while the modal is open.
    this._prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    var closeBtn = this.dom.modal.querySelector('.sl-modal__close');
    if (closeBtn) closeBtn.focus();
  };

  StoreLocator.prototype.closeProductsModal = function () {
    this.dom.modal.setAttribute('hidden', '');
    document.body.style.overflow = this._prevOverflow || '';
  };

  /* ------------------------------------------------------- selection --- */
  StoreLocator.prototype.selectStore = function (id, opts) {
    opts = opts || {};
    var self = this;
    var store = this.stores.filter(function (s) {
      return s.id === id;
    })[0];
    if (!store) return;

    var prevId = this.activeId;
    this.activeId = id;

    // Update card active states + scroll into view
    this.dom.list.querySelectorAll('.sl-card').forEach(function (c) {
      var isActive = c.getAttribute('data-id') === id;
      c.classList.toggle('is-active', isActive);
      if (isActive) {
        c.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });

    // Reset the previously-selected pin (if it's a currently-drawn singleton).
    if (prevId && prevId !== id && this.markers[prevId]) {
      this.markers[prevId].content = this.makePin(false).element;
      this.markers[prevId].zIndex = 1;
    }

    if (this.map) {
      var pos = { lat: store.lat, lng: store.lng };
      // Selecting a card pans the map — our move, not the user's.
      if (opts.pan !== false) {
        this.beginProgrammaticMove();
        this.map.panTo(pos);
      }

      var marker = this.markers[id];
      if (marker) {
        // Rendered as its own pin — highlight it.
        marker.content = this.makePin(true).element;
        marker.zIndex = 1000;
      } else if (opts.pan !== false && (this.map.getZoom() || 12) < 15) {
        // Inside a cluster — zoom in to break it out. The zoom re-cluster then
        // draws this store as a (highlighted, since it's activeId) singleton.
        this.beginProgrammaticMove();
        this.map.setZoom(Math.min(15, (this.map.getZoom() || 12) + 3));
      }

      // Anchor the info window to the store's position (not a marker), so it
      // works whether the store is an individual pin or inside a cluster.
      this.infoWindow.setContent(this.infoWindowContent(store));
      this.infoWindow.setPosition(pos);
      this.infoWindow.open({ map: this.map });
    }

    // On mobile, jump to the map so the selection is visible
    if (window.matchMedia('(max-width: 820px)').matches && this.map) {
      this.root.setAttribute('data-view', 'map');
      var mapBtn = this.dom.viewToggle.querySelector('[data-view-btn="map"]');
      if (mapBtn) this.setActivePill(mapBtn.parentNode, mapBtn);
      this.beginProgrammaticMove();
      this.map.panTo({ lat: store.lat, lng: store.lng });
    }
  };

  // Built as a real DOM element (setContent accepts an HTMLElement) so the
  // close/products controls get direct listeners — no event delegation needed
  // for content that lives inside the map. Mirrors the sidebar card's anatomy.
  StoreLocator.prototype.infoWindowContent = function (store) {
    var self = this;
    var cat = this.categories[store.type];
    var addr = escapeHtml(
      store.address + ', ' + store.city + ', ' + store.state + ' ' + store.zip
    );
    var telHref = 'tel:' + (store.phone || '').replace(/[^0-9+]/g, '');
    var mapsUrl =
      'https://www.google.com/maps/dir/?api=1&destination=' +
      encodeURIComponent(
        store.address + ', ' + store.city + ', ' + store.state + ' ' + store.zip
      );

    var html =
      '<div class="sl-iw__head">' +
      '<h3 class="sl-iw__name">' + escapeHtml(store.name) + '</h3>' +
      '<button type="button" class="sl-iw__close" aria-label="Close">' + ICONS.x + '</button>' +
      '</div>';

    var metaBits = [];
    if (cat) {
      metaBits.push(
        '<span class="sl-card__badge">' + categoryIcon(store.type) +
          escapeHtml(cat.label) + '</span>'
      );
    }
    if (store.distance != null) {
      metaBits.push('<span class="sl-iw__distance">' + formatDistance(store.distance) + '</span>');
    }
    if (metaBits.length) {
      html += '<div class="sl-iw__tags">' + metaBits.join('') + '</div>';
    }

    html += '<p class="sl-iw__meta">' + addr;
    if (store.hours) {
      html += '<br><span class="sl-card__hours">' + escapeHtml(store.hours) + '</span>';
    }
    if (store.phone) {
      html += '<br><a href="' + telHref + '">' + escapeHtml(store.phone) + '</a>';
    }
    html += '</p>';

    if (store.products && store.products.length) {
      html +=
        '<div class="sl-products">' +
        '<button type="button" class="sl-products__toggle sl-iw__products">' +
        ICONS.box + 'Available Products' +
        '<span class="sl-products__count">' + store.products.length + '</span>' +
        '</button>' +
        '</div>';
    }

    html +=
      '<div class="sl-iw__actions">' +
      '<a class="sl-btn sl-btn--primary" href="' + mapsUrl +
      '" target="_blank" rel="noopener">' + ICONS.directions + 'Directions</a>';
    if (store.phone) {
      html += '<a class="sl-btn" href="' + telHref + '">' + ICONS.phone + 'Call</a>';
    }
    html += '</div>';

    var wrap = el('div', 'sl-iw', html);
    wrap.querySelector('.sl-iw__close').addEventListener('click', function () {
      self.infoWindow.close();
    });
    var productsBtn = wrap.querySelector('.sl-iw__products');
    if (productsBtn) {
      productsBtn.addEventListener('click', function () {
        self.openProductsModal(store.id);
      });
    }
    return wrap;
  };

  /* ---------------------------------------------------------- bootstrap --- */
  function bootNodes(selector) {
    var nodes = document.querySelectorAll(selector);
    Array.prototype.forEach.call(nodes, function (node) {
      if (node.__slBooted) return;
      node.__slBooted = true;
      new StoreLocator(node);
    });
  }

  // Called by the Google Maps loader (&callback=slInitLocator). Boots every
  // locator once Maps is ready.
  window.slInitLocator = function () {
    bootNodes('[data-store-locator]');
  };

  // If the Maps API already loaded before this script (e.g. cached), boot now.
  if (window.google && window.google.maps) {
    window.slInitLocator();
  }

  // No-map locators (data-map="off") don't wait for Google — boot them as soon
  // as the DOM is ready so the proxy/list UI works without an API key.
  function bootMapless() {
    bootNodes('[data-store-locator][data-map="off"]');
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootMapless);
  } else {
    bootMapless();
  }
})();
